var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 836"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    opacity: 0.5,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#C1FAFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    opacity: 0.3,
    cx: 28,
    cy: 28,
    r: 20,
    fill: "#57B8D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "?",
    d: "M26.3223 33.5793C26.3223 32.7297 26.3609 31.9837 26.438 31.341C26.5262 30.6875 26.7466 30.034 27.0992 29.3805C27.4298 28.7597 27.8375 28.2478 28.3223 27.8448C28.8072 27.4309 29.314 27.0442 29.843 26.6848C30.3719 26.3145 30.8733 25.8788 31.3471 25.3778C31.7769 24.8877 32.0634 24.3921 32.2066 23.8911C32.3499 23.3901 32.4215 22.8618 32.4215 22.3063C32.4215 21.7509 32.3499 21.2553 32.2066 20.8196C32.0744 20.3839 31.865 20.0082 31.5785 19.6923C31.1377 19.1586 30.5978 18.7937 29.9587 18.5977C29.3196 18.4016 28.6529 18.3036 27.9587 18.3036C27.2755 18.3036 26.6364 18.4016 26.0413 18.5977C25.4573 18.7828 24.9725 19.0715 24.5868 19.4636C24.2121 19.8121 23.9366 20.2315 23.7603 20.7216C23.595 21.2117 23.5124 21.7291 23.5124 22.2737H21C21.0441 21.4132 21.2314 20.5745 21.562 19.7577C21.9036 18.9299 22.3994 18.2383 23.0496 17.6828C23.6997 17.0946 24.4545 16.6698 25.314 16.4084C26.1846 16.1361 27.0606 16 27.9421 16C29.022 16 30.0468 16.1634 31.0165 16.4901C31.9862 16.806 32.8017 17.3397 33.4628 18.0912C33.9917 18.6467 34.3774 19.2839 34.6198 20.0027C34.8733 20.7107 35 21.4677 35 22.2737C35 23.1777 34.8292 24.0272 34.4876 24.8223C34.146 25.6174 33.6667 26.3254 33.0496 26.9462C32.6749 27.3492 32.2507 27.725 31.7769 28.0735C31.303 28.4112 30.8457 28.7651 30.405 29.1355C29.9752 29.4949 29.6446 29.887 29.4132 30.3118C29.1267 30.8346 28.9669 31.3302 28.9339 31.7985C28.9118 32.2668 28.9008 32.8604 28.9008 33.5793H26.3223ZM26.3388 40V36.7978H28.9008V40H26.3388Z",
    fill: "#2E5D6A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.57a0832d893523781a9ef1583e729170.svg";
export { ForwardRef as ReactComponent };